import FormField from './form_field';

export default class CheckboxFormField extends FormField {
	_checked;
	_valueWhenChecked;

	constructor(fieldProps = {}) {
		super(fieldProps);

		this.checked = !!fieldProps.value;
		this.valueWhenChecked = fieldProps.valueWhenChecked;
	}

	get checked() {
		return this._checked;
	}

	set checked(value) {
		this.value = !value ? null : this._valueWhenChecked;
		this._checked = value;
	}

	get valueWhenChecked() {
		return this._valueWhenChecked;
	}

	set valueWhenChecked(value) {
		this._valueWhenChecked = value;
	}
}
